<ng-container *ngIf="data?.length && !loading && loadedOnce">

  <table class="esf-table"
         app-table
         [actionButtons]="actionButtons"
         [columns]="columns"
         [keys]="keys"
         [data]="data"
         (rowButtonClickEvent)="rowButtonClick($event)"
         (rowClickEvent)="rowClick($event)">
  </table>

  <app-paginator *ngIf="baseApi"
                 [pager]="pagerOptions.pager"
                 [viewList]="viewList"
                 (setPageEmitter)="setCurrentPage($event)"
                 (setViewEmitter)="setCurrentItems($event)">
  </app-paginator>

</ng-container>


<ng-container *ngIf="!data?.length && !loading && loadedOnce">

  <section class="esf-empty-state flex-empty-state"
           app-empty-state
           [emptyStateIcon]="emptyStateIcon"
           [emptyStateText]="emptyStateText"
           [emptyStateButtonText]="emptyStateButtonText"
           (actionButtonClickEvent)="actionButtonClick()">
  </section>

</ng-container>

<app-spinner [(show)]="loading"></app-spinner>
